import { useMemo } from 'react';

import { FORM_OPTIONS } from '@context/stock/buysell';
import useStockBuySellContext from './useStockBuySellContext';

const useGetOrderTypeOptions = () => {
  const { formState, formKey } = useStockBuySellContext();

  const orderTypeOptions = useMemo(() => {
    // Filter options based on available order types for each Account Type
    const filteredOptions = FORM_OPTIONS.ORDER_TYPE.filter((v) =>
      formState[formKey.INPUT_ACCOUNT_TYPE]?.orderTypes?.includes(v.key)
    );
    return filteredOptions;
  }, [formState]);

  return { orderTypeOptions };
};

export default useGetOrderTypeOptions;
